import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-hkmarketchannelgroup",
  "use": "icon-soc-m-hkmarketchannelgroup-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-hkmarketchannelgroup\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"660\" cy=\"180\" r=\"28\" /><path d=\"M352 448h320v128H352z\" /><circle cx=\"288\" cy=\"512\" r=\"128\" /><circle cx=\"736\" cy=\"512\" r=\"128\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-hkmarketchannelgroup.svg
// module id = nbU7
// module chunks = 478